import { render, staticRenderFns } from "./CardColorUsage.vue?vue&type=template&id=35ee14ed&scoped=true"
import script from "./CardColorUsage.vue?vue&type=script&lang=js"
export * from "./CardColorUsage.vue?vue&type=script&lang=js"
import style0 from "./CardColorUsage.vue?vue&type=style&index=0&id=35ee14ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee14ed",
  null
  
)

export default component.exports